var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "inputForDropMenu" }, [
    _c("div", [
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visibleDropdown,
            expression: "visibleDropdown"
          }
        ],
        ref: "jhCustomSelectInput",
        staticClass: "jh-custom-select-input",
        attrs: { type: "text" },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event.target.value)
          },
          focus: function($event) {
            return _vm.showDropdownMenu(true)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.visibleDropdown,
              expression: "!visibleDropdown"
            }
          ],
          staticClass: "jh-custom-select-input jh-custom-select-fake-input",
          on: {
            click: function($event) {
              return _vm.showDropdownMenu(true)
            }
          }
        },
        [_vm._v("\n            " + _vm._s(_vm.userSees) + "\n        ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "jh-custom-select-dropdown-switch-anchor" }, [
        _c(
          "div",
          { staticClass: "jh-custom-select-dropdown-switch" },
          [
            _c("SVGCrossClearField", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.userSees,
                  expression: "userSees"
                }
              ],
              staticClass: "clear-button",
              nativeOn: {
                click: function($event) {
                  return _vm.clearSelection()
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "jh-custom-select-dropdown-switch",
            on: {
              click: function($event) {
                return _vm.showDropdownMenu(!_vm.visibleDropdown)
              }
            }
          },
          [
            _vm.visibleArrow
              ? _c("SVGDropdownSwitchArrowUp", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.visibleDropdown,
                      expression: "visibleDropdown"
                    }
                  ]
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.visibleArrow
              ? _c("SVGDropdownSwitchArrowDown", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.visibleDropdown,
                      expression: "!visibleDropdown"
                    }
                  ]
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visibleDropdown,
            expression: "visibleDropdown"
          }
        ],
        staticClass: "jh-custom-select-dropdown-menu",
        style: _vm.widthDropdownMenu
      },
      [
        _c(
          "vue-custom-scrollbar",
          {
            staticClass: "jh-custom-select-dropdown",
            on: { "ps-y-reach-end": _vm.scrollReachEnd }
          },
          [
            _vm._l(_vm.selectOptions, function(option, prop) {
              return _c(
                "div",
                {
                  staticClass: "jh-custom-select-option",
                  on: {
                    click: function($event) {
                      _vm.selectOption(
                        _vm.selectableParamCondition(option, prop),
                        _vm.selectName(option, prop)
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.selectName(option, prop)) +
                      "\n                "
                  ),
                  _vm.selectDescription
                    ? _c(
                        "div",
                        { staticClass: "jh-custom-select-option-description" },
                        [_vm._v(_vm._s(_vm.selectDescription(option, prop)))]
                      )
                    : _vm._e()
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleMessageLoading,
                    expression: "visibleMessageLoading"
                  }
                ],
                staticClass: "jh-custom-select-loader-grid"
              },
              [
                _c("SpinnerTwo", { staticClass: "jh-custom-select-spinner" }),
                _vm._v(" "),
                _c("div", { staticClass: "jh-custom-select-loader-text" }, [
                  _vm._v("\n                    Загрузка ...\n                ")
                ])
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }